import React from "react";
import { Box, Typography } from "@mui/material";

const STEPS = [
  { key: "submitted", label: "Submitted" },
  { key: "action_required", label: "Action Required" },
  { key: "processing", label: "Processing" },
  { key: "awaiting_review", label: "Awaiting Review" },
  { key: "ready", label: "Ready" },
  { key: "revision_requested", label: "Change Request" },
  { key: "completed", label: "Completed" },
  { key: "failed_or_cancelled", label: "Failed / Cancelled" },
];

const ORDERED = ["submitted", "action_required", "processing", "awaiting_review", "ready", "revision_requested", "completed"];

export default function BinatedLifecycleTimeline({ normalizedStatus }) {
  const status = String(normalizedStatus || "submitted").toLowerCase();
  const activeKey =
    status === "failed" || status === "cancelled" ? "failed_or_cancelled" : status;
  const activeIdx = activeKey === "failed_or_cancelled"
    ? STEPS.findIndex((s) => s.key === "failed_or_cancelled")
    : Math.max(0, ORDERED.indexOf(activeKey));

  return (
    <Box sx={{ mt: 1.5, display: "grid", gridTemplateColumns: "repeat(8, minmax(0,1fr))", gap: 0.75 }}>
      {STEPS.map((step, idx) => {
        const isComplete = activeKey !== "failed_or_cancelled" && idx <= activeIdx;
        const isActive = step.key === activeKey;
        const isFailedLane = step.key === "failed_or_cancelled";
        const isActionRequiredLane = step.key === "action_required";
        return (
          <Box
            key={step.key}
            sx={{
              px: 0.75,
              py: 0.6,
              textAlign: "center",
              borderRadius: 1,
              border: "1px solid",
              borderColor: isActive
                ? isFailedLane
                  ? "#ef4444"
                  : isActionRequiredLane
                    ? "#d97706"
                    : "#2563eb"
                : "#e5e7eb",
              background: isActive
                ? isFailedLane
                  ? "#fee2e2"
                  : isActionRequiredLane
                    ? "#fef3c7"
                    : "#dbeafe"
                : (isComplete ? "#ecfeff" : "#fff"),
            }}
          >
            <Typography variant="caption" sx={{ fontWeight: isActive ? 700 : 500 }}>
              {step.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
